<template>
  <div class="home">
    <header>
      <h4 class="two-homes">Domeó developments presents</h4>
      <br />
      <img class="logo" src="/domeo.svg" />
      <h1 class="logo">7 Malmsbury St, Kew</h1>
      <h4 class="two-homes">
        The epitome of class in two<br />distinctive luxury homes
      </h4>
    </header>

    <!-- <Button href="#enquire" fixed label="Enquire now" /> -->

    <HeroImage rotateOnMobile fitToWidth image="/images/renders/1.jpg" />

    <section>
      <ul class="icons">
        <li>
          <img class="icon" src="/images/icons/icon-bed.svg" />
          <h3>4</h3>
        </li>
        <li>
          <img class="icon" src="/images/icons/icon-bath.svg" />
          <h3>3</h3>
        </li>
        <li>
          <img class="icon" src="/images/icons/icon-car.svg" />
          <h3>3</h3>
        </li>
      </ul>

      <hr />
      <h2>
        Cutting edge design and technology blended with luxurious finishes
      </h2>
      <hr />
      <p>
        Developed by Domeó Developments, these three storey homes in one of
        Melbourne's most affluent suburbs are set to define the neighbourhood.
      </p>
      <p>
        Strolling up the floating steps, surrounded by beautifully landscaped
        shrubbery, magnificent full-height doors that lead to the spacious
        entryway will greet you.
      </p>
    </section>

    <HeroImage fitToWidth rotateOnMobile image="/images/renders/2.jpg" />

    <section>
      <p>
        In the interior, timber floorboards and discreet ducted heating and
        cooling make the home feel cozy from the minute you step foot inside.
      </p>
      <hr />
      <h2>
        To create an exceptional indoor-outdoor flow, the interior borrows
        heavily from nature
      </h2>
      <hr />
      <p>
        The space achieves a cohesive feel because each living area has
        sophisticated finishes that uphold the master plan. The first of these
        finishes is the luxurious floor-to-ceiling Venetian plaster feature wall
        in the entryway.
      </p>
    </section>

    <HeroImage fitToWidth rotateOnMobile image="/images/renders/3.jpg" />

    <section>
      <p>
        To create open-plan movement in the home, the entryway leads to a
        spacious kitchen with its impeccable signature accents of brushed nickel
        hardware and matte black appliances.
      </p>

      <!-- <hr /> -->
      <Plans />
      <!-- <hr /> -->

      <p>
        Designed to become the heart of the home, the kitchen has also been
        fitted with coveted concrete-look benchtops and fully integrated
        hardware.
      </p>
    </section>

    <HeroImage fitToWidth rotateOnMobile image="/images/renders/4.jpg" />

    <section>
      <p>
        The numerous living spaces – with elements like stone, timber, and
        abundant natural light – maintain the indoor-outdoor flow to enhance
        these homes' entertainer appeal.
      </p>
      <hr />
    </section>

    <br />
    <Materials>
      <Material
        name="Prestige Oak Flooring"
        image="/images/materials/material-oak.png"
      />
      <Material
        name="Caesarstone Rugged Concrete"
        image="/images/materials/material-concrete.png"
      />
      <Material
        name="Premium 100% Wool Carpet"
        image="/images/materials/material-carpet.png"
      />
      <Material
        name="Feature Wall"
        image="/images/materials/material-wall.png"
      />
    </Materials>

    <section>
      <hr />

      <p>
        Fall in love with the geometrical finishes in the powder room.
        Amplifying the list of luxury features, the powder room completes the
        lower level with its gold, concrete, and timber accents.
      </p>
    </section>

    <HeroImage fitToWidth rotateOnMobile image="/images/renders/5.jpg" />

    <section>
      <p>On the second floor, the floor-to-ceiling design continues.</p>

      <hr />
      <h2>Serenity inspired every design element</h2>
      <hr />

      <p>
        Full-height doors welcome you into the master bedroom, where serenity
        inspires every design element – from the woven carpeting to the pendant
        lights beside the bed and the gorgeous timber components that feature
        prominently.
      </p>
    </section>

    <HeroImage fitToWidth rotateOnMobile image="/images/renders/6.jpg" />

    <section>
      <ul class="features icons">
        <li>
          <img src="/images/features/climate.svg" />
          <h4>Heating & cooling</h4>
          <p class="small">Multi-zoned ducted climate control</p>
        </li>
        <li>
          <img src="/images/features/fireplace.svg" />
          <h4>Fireplace</h4>
          <p class="small">Including feature wall</p>
        </li>
      </ul>
      <ul class="icons">
        <li>
          <img src="/images/features/oven.svg" />
          <h4>Miele appliances</h4>
          <p class="small">High-end domestic appliances</p>
        </li>
        <li>
          <img src="/images/features/phone.svg" />
          <h4>Home automation</h4>
          <p class="small">Digital home controls</p>
        </li>
      </ul>
      <ul class="icons">
        <li>
          <img src="/images/features/camera.svg" />
          <h4>Security system</h4>
          <p class="small">Alarm and camera system</p>
        </li>
        <li>
          <img src="/images/features/lift.svg" />
          <h4>Lift</h4>
          <p class="small">All level access</p>
        </li>
      </ul>
      <ul class="icons">
        <li>
          <img src="/images/features/pool.svg" />
          <h4>Pool</h4>
          <p class="small">Luxury living</p>
        </li>
      </ul>
    </section>
    <HeroImage fitToWidth image="/images/renders/7.jpg" />

    <section>
      <p>
        Unwind in the spa-inspired bathroom with brushed nickel hardware,
        ceramic amenities, and full wall marble tiling.
      </p>

      <hr />
      <h2>"An elegant entertainer’s paradise"</h2>

      <hr />

      <p>
        Indoor-outdoor living space is not complete without unparalleled outdoor
        space. These homes continue this elegant entertainer’s paradise in the
        backyard, where entertaining can take place around the sparkling pool or
        the firepit. This home awaits you.
      </p>
    </section>

    <div class="stackedImages">
      <HeroImage fitToWidth image="/images/renders/9.jpg" />
      <transition name="fade">
        <HeroImage
          v-if="showStackedImage"
          overlay
          fitToWidth
          image="/images/renders/8.jpg"
        />
      </transition>
    </div>

    <section>
      <br id="enquire" />
      <h4>Kay &amp; Burton</h4>
      <br />
      <h2 class="large">Sam Wilkinson</h2>
      <p>
        <a href="tel:+61400169148">Call on 0400 169 148</a>
        <br />
        <a href="mailto:swilkinson@kayburton.com.au">Email Sam Wilkinson</a>
      </p>
    </section>
    <footer>
      <img class="logo" src="/domeo.svg" />
      <h4 style="margin-top: -30px; font-size: 13px">Developments</h4>
      <br />
      <br />
      <br />
      <br />
      <p class="belvedere small">
        Visuals and website by
        <a target="_blank" href="https://www.belvedere3d.com">Belvedere 3D</a>
      </p>
    </footer>
  </div>
</template>

<script>
import HeroImage from "./../components/hero-image";
import Material from "@/components/material";
import Materials from "@/components/materials";
import Plans from "@/components/plans";

export default {
  name: "Home",
  data() {
    return {
      showStackedImage: false,
    };
  },
  components: {
    HeroImage,
    Material,
    Materials,
    Plans,
  },
  mounted() {
    setInterval(() => {
      this.showStackedImage = !this.showStackedImage;
    }, 6000);
  },
};
</script>

<style scoped lang="scss">
.two-homes {
  margin: -24px 0 0;
  padding: 0 0 24px;
  color: #7f8382;
}

.floorplan-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.1);
  height: 400px;
  margin-bottom: 32px;
}

.home {
  display: flex;
  flex-direction: column;
  text-align: center;
}

header,
section,
footer {
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 600px;
  max-width: 80vw;
  align-self: center;
}

header {
  margin-top: calc(10vw + 32px);

  img.logo {
    width: 128px;
    margin-bottom: 32px;
    border: none;
    align-self: center;

    @media screen and (max-width: 800px) {
      width: 96px;
    }
  }

  h1.logo {
    font-size: 24px;
    margin-top: 16px;
    letter-spacing: 0.1em;
  }
}

footer {
  margin-top: 10vw;
  margin-bottom: 6vw;

  .belvedere a {
    color: #7f8382;
    border-color: #7f8382;
  }

  img.logo {
    width: 128px;
    margin-bottom: 32px;
    border: none;
    align-self: center;
  }
}

.icons {
  display: flex;
  max-width: 80vw;
  justify-content: space-around;
  box-sizing: border-box;
  flex-direction: row;
  margin: 32px 0 32px;
  padding: 0;
  list-style-type: none;

  & + .icons {
    margin-top: -32px;
  }

  li {
    width: 240px;
    padding: 0;
    margin: 0 16px;

    h3 {
      margin-top: 0;
    }

    p {
      padding: 0;
      width: auto;
    }
  }
}

.stackedImages {
  display: flex;
  position: relative;
  max-width: 100vw;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 6s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
